import CONFIG from '@/environments/config';

export default {
    data() {
      return {
        config : CONFIG,
      };
    },
    methods: {
      joinToDateString(clazz, field, spliter) {
        spliter = spliter || ', ';
        return clazz ? clazz.filter(c => c).map(c => this.toFormatedDate(c[field])).join(spliter) : '';
      },
      joinToString(clazz, field, spliter) {
        spliter = spliter || ', ';
        return clazz ? clazz.filter(c => c).map(c => c[field].replace( /(<([^>]+)>)/ig, '')).join(spliter) : '';
      },
      toFormatedDate(dateString) {
        if(!dateString) {
          return null;
        }

        const d = new Date(dateString);
        return this.zf(d.getDate(), 2) + '/' + this.zf((d.getMonth() + 1), 2) + '/' + d.getFullYear();
      },
      zf(data, len){
        const d = '' + data;
        const pd = function(char, l){var s = '', i = 0; while (i++ < l) { s += char; } return s;};
        return pd("0", len - d.length) + d;
      },
      stripTag(str) {
        return str ? str.replace( /(<([^>]+)>)/ig, '') : '';
      },
      download(fileURL, fileName) {
        // for non-IE
        if (!window.ActiveXObject) {
            var save = document.createElement('a');
            save.href = fileURL;
            // save.target = '_blank';
            save.download = fileName || 'unknown';
    
            var evt = new MouseEvent('click', {
                'view': window,
                'bubbles': true,
                'cancelable': false
            });
            save.dispatchEvent(evt);
    
            (window.URL || window.webkitURL).revokeObjectURL(save.href);
        }
        // for IE < 11
        else if ( !! window.ActiveXObject && document.execCommand)     {
            var _window = window.open(fileURL);//, '_blank');
            _window.document.close();
            _window.document.execCommand('SaveAs', true, fileName || fileURL)
            _window.close();
        }
      }
    }
  }
  